import React from "react";
import styled from "styled-components";
const StyledWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: stretch;
  align-items: center;
  margin-bottom: 1rem;

  @media (min-width: ${props => props.theme.screenWidthXxs}) {
    align-items: flex-start;
    margin-bottom: 0;
  }

  @media (min-width: ${props => props.theme.screenWidthMd}) {
    align-items: flex-start;
    margin-right: 1rem;
    margin-bottom: 0;
  }
`;

const Wrapper = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(StyledWrapper, null, children);
};

export default Wrapper;